import { createBusinessId } from '@/businessRepository/idUtils';
import { IForecastStaff } from '@/coreDomainsModule/entities/forecast';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { TableContentItem } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import { GetForecastForReceiptSummaryData } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * -
 */
export class ForecastForReceiptService {
  /**
   * -
   * @param items -
   */
  public static displayContentStaffFilterTable = (items: IForecastStaff[]): TableContentItem[] => {
    const displayTableContent: TableContentItem[] = [];
    items.forEach((item) => {
      const business = BusinessFactory.create();
      business.businessId = createBusinessId();
      displayTableContent.push({
        displayId: business.businessId,
        isVirtualChild: false,
        ...business,
        ...item,
      });
    });
    return displayTableContent;
  };

  /**
   * 検索結果テーブル用のデータを生成する
   * @param items - 受領用内示ごとの回収状況
   */
  public static displayContentSearchResultTable = (items: GetForecastForReceiptSummaryData[]): TableContentItem[] => {
    const displayTableContent: TableContentItem[] = [];
    items.forEach((item) => {
      const business = BusinessFactory.create();
      business.businessId = createBusinessId();
      displayTableContent.push({
        displayId: business.businessId,
        isVirtualChild: false,
        ...business,
        forecastForReceiptId: item.forecastForReceiptId,
        forecastForReceiptName: item.forecastForReceiptName,
        forecastForReceiptResponsibleUsers: item.userList?.map((u) => UserAccountFactory.create({ email: u.id, name: u.name })),
        keyword: item.keyword,
        recoveredForecastCount: item.recoveredForecastCount,
        totalForecastCount: item.totalForecastCount,
        latestUpdateAt: item.latestUpdateAt ?? null,
      });
    });
    return displayTableContent;
  };
}
